type HeaderCtaFields = {
  ctaType?: string
  ctaTarget?: string | number | null
  service?: string | number | null
  promoService?: string | number | null
  promoCtaType?: string
  page?: string
}

const isServiceIdTarget = (value: string | number | null | undefined, serviceIds: Array<string | number>): boolean => {
  if (value == null || value === "") return false

  return serviceIds.map(String).includes(String(value))
}

/** Header CTA service id only — never promoService or a page slug. */
export const resolveHeaderCtaService = (
  header: HeaderCtaFields | null | undefined,
  serviceIds: Array<string | number>
): string => {
  if (!header || header.ctaType !== "service") return ""

  const candidates = [header.service, header.ctaTarget]
  for (const candidate of candidates) {
    if (isServiceIdTarget(candidate, serviceIds)) return String(candidate)
  }

  return ""
}

export const headerCtaTarget = ({
  ctaType,
  ctaService,
  page,
  externalUrl
}: {
  ctaType: string
  ctaService: string
  page: string
  externalUrl: string
}): string => {
  if (ctaType === "service") return ctaService
  if (ctaType === "external") return externalUrl
  return page
}

export const headerThemeCtaFields = ({
  ctaType,
  ctaService,
  page,
  externalUrl
}: {
  ctaType: string
  ctaService: string
  page: string
  externalUrl: string
}): { service: string; ctaAction: string; ctaTarget: string } => ({
  service: ctaService,
  ctaAction: ctaType,
  ctaTarget: headerCtaTarget({ ctaType, ctaService, page, externalUrl })
})
